import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { FaDuotoneIconComponent, FaIconComponent, FaLayersComponent } from '@fortawesome/angular-fontawesome';
import { faEgg, faRabbitFast } from '@fortawesome/pro-duotone-svg-icons';

@Component({
  selector: 'rcp-rabbit-icon',
  template: `
    <span>
      @if (!isEaster) {
        <fa-icon [icon]="faRabbitFast"></fa-icon>
      }

      @if (isEaster) {
        <fa-layers [fixedWidth]="true">
          <fa-icon [icon]="faRabbitFast"></fa-icon>
          <fa-duotone-icon
            [icon]="faEgg"
            class="egg"
            transform="shrink-4"
            primaryOpacity="0.5"
            primaryColor="pink"
            secondaryColor="blue"
          ></fa-duotone-icon>
        </fa-layers>
      }
    </span>
  `,
  styles: [
    `
      span {
        margin-right: 10px;
      }

      .egg {
        position: absolute;
        top: 13px;
        right: -2px;
      }
    `,
  ],
  imports: [FaIconComponent, FaLayersComponent, FaDuotoneIconComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RabbitIconComponent implements OnInit {
  isEaster: boolean;

  protected readonly faRabbitFast = faRabbitFast;
  protected readonly faEgg = faEgg;

  ngOnInit(): void {
    const today = new Date();
    const [month, day] = this.getEaster(today.getFullYear());

    this.isEaster = today.getDate() === day && today.getMonth() === month - 1;
  }

  /**
   * Calculates Easter in the Gregorian/Western (Catholic and Protestant) calendar
   * based on the algorithm by Oudin (1940) from http://www.tondering.dk/claus/cal/easter.php
   * @returns {array} [int month, int day]
   */
  getEaster(year: number) {
    const f = Math.floor,
      // Golden Number - 1
      G = year % 19,
      C = f(year / 100),
      // related to Epact
      H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
      // number of days from 21 March to the Paschal full moon
      I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
      // weekday for the Paschal full moon
      J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
      // number of days from 21 March to the Sunday on or before the Paschal full moon
      L = I - J,
      month = 3 + f((L + 40) / 44),
      day = L + 28 - 31 * f(month / 4);

    return [month, day];
  }
}
